export default __webpack_public_path__ + "static/media/video-0.39adf7fe.mp4";